import { createGetAsyncSlice } from '@sonar-software/xuder';
import { IssueVisibilityType } from '../../@types';
import { getIssues, GetIssuesRequestWithoutVisibility } from '../../api';

function handler(request: GetIssuesRequestWithoutVisibility) {
	return getIssues({
		...request,
		visibilityType: IssueVisibilityType.Snoozed
	});
}

export const issuesSnoozedGetSlice = createGetAsyncSlice({
	name: 'issuesSnoozed',
	receive: true,
	request: true,
	requestHandler: handler,
	retainDataOnRequest: true
});
